export default "__VITE_ASSET__NJoGPgDQwNEm7BbXfid6Tw__"